import { useLocation } from 'react-router-dom'

function useURLParams() {
  return new URLSearchParams(useLocation().search)
}

export default useURLParams
